import * as yup from 'yup';
import translation from 'i18n/translation.json';
import { GARegisterEvent } from 'utils';

export const usePhoneNumberSchema = (page?: string) => {
  const isPaymentPage = page === 'payment';

  const schema = yup.object({
    phoneNumber: yup
      .string()
      .required(() => {
        GARegisterEvent({
          event: 'error_data',
          label: 'sign_up',
          stage: 'phone_number',
          field_name: 'phone_number',
          error_text: 'error_frontend: Phone number field is required',
        });

        return translation.errors.requiredField;
      })
      .test(
        '9-digits-in-number',
        () => {
          GARegisterEvent({
            event: 'error_data',
            label: 'sign_up',
            field_name: 'phone_number',
            error_text: 'error_frontend: The phone number should contain 9 digits, without the country code',
          });
          return isPaymentPage ? 'Por favor, ingresa el número correcto' : translation.errors.pnoneNumberLength;
        },
        value => {
          if (value) {
            return [9].includes(value.replace(/ /g, '').length);
          }
          return true;
        },
      )
      .test(
        'starts-with-9',
        () => {
          GARegisterEvent({
            event: 'error_data',
            label: 'sign_up',
            stage: 'phone_number',
            field_name: 'phone_number',
            error_text: `error_backend: The phone number should start with 9`,
          });
          return translation.errors.invalidPhoneNumber;
        },
        value => {
          if (value) {
            return value.startsWith('9');
          }
          return true;
        },
      ),
    otpType: yup.string().optional().notRequired(),
  });

  const defaultValue: yup.InferType<typeof schema> = {
    phoneNumber: '',
    otpType: 'sms',
  };

  return { schema, defaultValue };
};
